class RusayCollectionHub extends HTMLElement {
  connectedCallback() {
    this.#tabs = this.querySelectorAll('[data-hub-tab]');
    this.#panels = this.querySelectorAll('[data-hub-panel]');
    this.#defaultTab = this.dataset.defaultTab || 'women';

    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#activate(tab.dataset.hubTab));
    });

    this.#activate(this.#defaultTab);
  }

  /** @type {NodeListOf<HTMLButtonElement>} */
  #tabs;

  /** @type {NodeListOf<HTMLElement>} */
  #panels;

  /** @type {string} */
  #defaultTab;

  /**
   * @param {string | undefined} tabName
   */
  #activate(tabName) {
    if (!tabName) return;

    this.#tabs.forEach((tab) => {
      const isActive = tab.dataset.hubTab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.#panels.forEach((panel) => {
      panel.hidden = panel.dataset.hubPanel !== tabName;
    });
  }
}

if (!customElements.get('rusay-collection-hub')) {
  customElements.define('rusay-collection-hub', RusayCollectionHub);
}
